import Vue from "vue";
import LanguageSwitch from "./LanguageSwitch.vue";

// 注册全局组件
Vue.component("LanguageSwitch", LanguageSwitch);

export default {
	LanguageSwitch,
};
